// extracted by mini-css-extract-plugin
export var addressFields = "_jx-0";
export var animationContainer = "_jx-1";
export var footer = "_jx-2";
export var lineItems = "_jx-3";
export var modalContent = "_jx-4";
export var orderName = "_jx-5";
export var strong = "_jx-6";
export var warning = "_jx-7";